import React from 'react';

const ConstructionCommissioning = () => {
  return (
    <div className="page-content">
      {/* OPTION 9: Image Grid Collage Header */}
      <section className="page-hero service-hero-grid" style={{
        position: 'relative',
        minHeight: '500px',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        marginTop: '120px',
        paddingTop: '3rem',
        paddingBottom: '3rem'
      }}>
        {/* Image Grid Background */}
        <div className="service-hero-grid-bg" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '1rem',
          padding: '1rem',
          zIndex: 1
        }}>
          {[...Array(8)].map((_, i) => (
            <div key={i} style={{
              background: `linear-gradient(${135 + i * 20}deg, rgba(0, 104, 166, 0.6) 0%, rgba(171, 22, 54, 0.6) 100%)`,
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span className="material-icons" style={{fontSize: '3rem', color: 'rgba(255, 255, 255, 0.3)'}}>
                {['construction', 'build', 'verified', 'settings', 'business', 'dns', 'local_hospital', 'engineering'][i]}
              </span>
            </div>
          ))}
        </div>
        
        {/* Dark Overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          zIndex: 2
        }}></div>
        
        <div className="container" style={{position: 'relative', zIndex: 3, textAlign: 'center', padding: '4rem 20px'}}>
          <div style={{maxWidth: '800px', margin: '0 auto'}}>
            <div className="service-badge" style={{
              display: 'inline-block',
              fontSize: '0.9rem',
              fontWeight: '600',
              color: 'var(--white)',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              paddingBottom: '0.5rem',
              borderBottom: '3px solid var(--accent-blue)',
              marginBottom: '2rem'
            }}>
              Professional Services
            </div>
            
            <h1 className="service-title" style={{
              color: 'var(--white)',
              fontSize: '4.5rem',
              fontWeight: '700',
              marginBottom: '1.5rem',
              lineHeight: '1.1'
            }}>
              Construction through Commissioning
            </h1>
            
            <p className="service-subtitle" style={{
              color: 'rgba(255, 255, 255, 0.95)',
              fontSize: '1.5rem',
              lineHeight: '1.6',
              marginBottom: '0'
            }}>
              Complete project delivery from construction to commissioning and beyond
            </p>
          </div>
        </div>
      </section>

      {/* Section 1: Commissioning Process */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Commissioning Excellence</h2>
            <p>A structured process to verify and document building system performance</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '1.5rem'}}>
                Commissioning is a structured process to verify and document that applicable building systems meet the design intent and owners operational requirements.
              </p>
              
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)'}}>
                During the verification process the commissioner will be checking that all drawings, specs, and submittals meet the expectation of the job. <strong style={{color: 'var(--accent-blue)'}}>Bel-Aire Mechanical prides itself on providing the highest quality of service and product.</strong> Our goal at Bel-Aire Mechanical is to give the customer a quality product that meets the expectation of the owner.
              </p>
            </div>
            
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Commissioning Process Image]
            </div>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '0 auto'}}>
            <h3 style={{fontSize: '1.8rem', marginBottom: '2rem', color: 'var(--accent-blue)', textAlign: 'center'}}>Four-Phase Verification Process</h3>
            <div className="commissioning-verification-grid" style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(2, 1fr)', 
              gap: '1.5rem'
            }}>
              <div className="commissioning-verification-card commissioning-card-blue" style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(0, 104, 166, 0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
              }}>
                <span className="material-icons commissioning-card-icon" style={{fontSize: '2.5rem', opacity: 0.9}}>precision_manufacturing</span>
                <div>
                  <h4 className="commissioning-card-title" style={{color: 'var(--white)', fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: '600'}}>1. Verification of Equipment</h4>
                  <p className="commissioning-card-text" style={{fontSize: '0.95rem', color: 'rgba(255, 255, 255, 0.9)', margin: 0}}>Thorough inspection and validation of all mechanical equipment</p>
                </div>
              </div>
              
              <div className="commissioning-verification-card commissioning-card-red" style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(171, 22, 54, 0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
              }}>
                <span className="material-icons commissioning-card-icon" style={{fontSize: '2.5rem', opacity: 0.9}}>build</span>
                <div>
                  <h4 className="commissioning-card-title" style={{color: 'var(--white)', fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: '600'}}>2. Verification of Equipment Install</h4>
                  <p className="commissioning-card-text" style={{fontSize: '0.95rem', color: 'rgba(255, 255, 255, 0.9)', margin: 0}}>Ensuring proper installation according to specifications</p>
                </div>
              </div>
              
              <div className="commissioning-verification-card commissioning-card-red" style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(171, 22, 54, 0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
              }}>
                <span className="material-icons commissioning-card-icon" style={{fontSize: '2.5rem', opacity: 0.9}}>power</span>
                <div>
                  <h4 className="commissioning-card-title" style={{color: 'var(--white)', fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: '600'}}>3. Verification of Equipment Startup</h4>
                  <p className="commissioning-card-text" style={{fontSize: '0.95rem', color: 'rgba(255, 255, 255, 0.9)', margin: 0}}>Systematic startup procedures and initial operation testing</p>
                </div>
              </div>
              
              <div className="commissioning-verification-card commissioning-card-blue" style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(0, 104, 166, 0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
              }}>
                <span className="material-icons commissioning-card-icon" style={{fontSize: '2.5rem', opacity: 0.9}}>settings</span>
                <div>
                  <h4 className="commissioning-card-title" style={{color: 'var(--white)', fontSize: '1.2rem', marginBottom: '0.5rem', fontWeight: '600'}}>4. Verification of Equipment Operation</h4>
                  <p className="commissioning-card-text" style={{fontSize: '0.95rem', color: 'rgba(255, 255, 255, 0.9)', margin: 0}}>Final validation of optimal system performance</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Construction Process */}
      <section className="section" style={{background: 'linear-gradient(180deg, var(--white) 0%, var(--secondary-light) 100%)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Comprehensive Construction Process</h2>
            <p>From groundbreaking to final handover - complete project execution</p>
          </div>
          
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center'}} className="precon-grid-2col">
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Construction Site Image]
            </div>
            
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                From groundbreaking to final commissioning, Bel-Aire Mechanical provides comprehensive project management and execution services for <strong style={{color: 'var(--accent-blue)'}}>commercial real estate projects</strong>. Our experienced team specializes in mission-critical facilities including data centers and hospitals, ensuring seamless coordination throughout every phase of construction.
              </p>
              
              <div style={{background: 'var(--accent-blue)', color: 'var(--white)', padding: '2rem', borderRadius: '10px'}}>
                <h3 style={{color: 'var(--white)', fontSize: '1.3rem', marginBottom: '1rem'}}>Commercial Construction Excellence</h3>
                <p style={{fontSize: '1.05rem', lineHeight: '1.7', color: 'rgba(255, 255, 255, 0.95)', margin: 0}}>
                  We combine advanced BIM/VDC technologies with proven commercial construction methods to deliver complex projects on time, within budget, and exceeding quality expectations. Our specialized approach ensures optimal coordination for mission-critical facilities that demand the highest standards.
                </p>
              </div>
            </div>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '3rem auto 0'}}>
            <div className="commissioning-phases-grid" style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(4, 1fr)', 
              gap: '1rem'
            }}>
              <div className="commissioning-phase-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent-blue)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)', marginBottom: '0.5rem'}}>Planning & Coordination</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Detailed project planning and stakeholder coordination</p>
              </div>
              <div className="commissioning-phase-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent2-red)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent2-red)', marginBottom: '0.5rem'}}>Installation</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Professional installation of all mechanical systems</p>
              </div>
              <div className="commissioning-phase-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent-blue)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent-blue)', marginBottom: '0.5rem'}}>Testing & Validation</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Comprehensive testing to ensure specifications</p>
              </div>
              <div className="commissioning-phase-card" style={{
                background: 'var(--white)', 
                padding: '1.5rem', 
                borderRadius: '8px', 
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)', 
                textAlign: 'center',
                border: '2px solid var(--accent2-red)'
              }}>
                <h4 style={{fontSize: '1rem', fontWeight: '600', color: 'var(--accent2-red)', marginBottom: '0.5rem'}}>Commissioning</h4>
                <p style={{fontSize: '0.9rem', color: 'var(--gray-600)', margin: 0}}>Final commissioning and complete documentation</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Specialized Commercial Markets */}
      <section className="section" style={{background: 'var(--white)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Specialized Commercial Markets</h2>
            <p>Mission-critical facilities requiring the highest standards of mechanical systems</p>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '0 auto'}}>
            <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
              <div>
                <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                  Bel-Aire Mechanical specializes in <strong style={{color: 'var(--accent-blue)'}}>commercial real estate construction</strong>, with particular expertise in mission-critical facilities that demand the highest levels of reliability and performance. Our focus on data centers and hospitals reflects our commitment to excellence in the most demanding environments.
                </p>
                
                <div style={{background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', color: 'var(--white)', padding: '2.5rem', borderRadius: '10px', boxShadow: '0 6px 25px rgba(171, 22, 54, 0.3)'}}>
                  <h3 style={{color: 'var(--white)', fontSize: '1.3rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.75rem'}}>
                    <span className="material-icons" style={{fontSize: '1.5rem'}}>business</span>
                    Commercial Focus
                  </h3>
                  <p style={{fontSize: '1.05rem', lineHeight: '1.8', color: 'rgba(255, 255, 255, 0.95)', margin: 0}}>
                    We exclusively serve commercial real estate markets, bringing specialized knowledge and experience to complex projects that require advanced mechanical systems, strict compliance standards, and mission-critical reliability.
                  </p>
                </div>
              </div>
              
              <div className="image-placeholder" style={{minHeight: '350px'}}>
                [Commercial Construction Site Image]
              </div>
            </div>
            
            <div className="commissioning-markets-grid" style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(2, 1fr)', 
              gap: '2rem'
            }}>
              <div className="commissioning-market-card commissioning-market-blue" style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2.5rem', 
                borderRadius: '12px', 
                textAlign: 'center', 
                boxShadow: '0 6px 20px rgba(0, 104, 166, 0.2)'
              }}>
                <div style={{fontSize: '4rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>dns</span></div>
                <h3 style={{fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--white)'}}>Data Centers</h3>
                <p style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1rem'}}>Specialized cooling systems and environmental control for mission-critical computing infrastructure.</p>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>Precision cooling systems</li>
                  <li>Redundant HVAC infrastructure</li>
                  <li>Environmental monitoring systems</li>
                  <li>Emergency backup systems</li>
                </ul>
              </div>
              
              <div className="commissioning-market-card commissioning-market-red" style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2.5rem', 
                borderRadius: '12px', 
                textAlign: 'center', 
                boxShadow: '0 6px 20px rgba(171, 22, 54, 0.2)'
              }}>
                <div style={{fontSize: '4rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>local_hospital</span></div>
                <h3 style={{fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--white)'}}>Hospitals & Healthcare</h3>
                <p style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1rem'}}>Advanced HVAC systems for medical facilities requiring strict environmental control and patient safety.</p>
                <ul style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem', lineHeight: '1.6', textAlign: 'left', margin: 0}}>
                  <li>Operating room HVAC systems</li>
                  <li>Infection control ventilation</li>
                  <li>Medical gas systems</li>
                  <li>Emergency power systems</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 4: Quality Assurance */}
      <section className="section" style={{background: 'linear-gradient(180deg, var(--white) 0%, var(--secondary-light) 100%)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Quality Assurance & Documentation</h2>
            <p>Comprehensive quality control throughout the entire project lifecycle</p>
          </div>
          
          <div className="precon-grid-2col" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', alignItems: 'center', marginBottom: '3rem'}}>
            <div>
              <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--gray-600)', marginBottom: '2rem'}}>
                Our quality assurance process begins during the design phase and continues through final commissioning. We maintain detailed documentation and conduct rigorous testing to ensure every system meets or exceeds project specifications.
              </p>
              
              <div style={{background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', color: 'var(--white)', padding: '2.5rem', borderRadius: '10px', boxShadow: '0 6px 25px rgba(171, 22, 54, 0.3)'}}>
                <h3 style={{color: 'var(--white)', fontSize: '1.3rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.75rem'}}>
                  <span className="material-icons" style={{fontSize: '1.5rem'}}>verified</span>
                  Quality Commitment
                </h3>
                <p style={{fontSize: '1.05rem', lineHeight: '1.8', color: 'rgba(255, 255, 255, 0.95)', margin: 0}}>
                  Bel-Aire Mechanical's commitment to quality extends beyond installation. We provide comprehensive training, operation manuals, and ongoing support to ensure optimal system performance throughout the building's lifecycle.
                </p>
              </div>
            </div>
            
            <div className="image-placeholder" style={{minHeight: '350px'}}>
              [Quality Assurance Process Image]
            </div>
          </div>
        </div>
      </section>

      {/* Section 5: Construction Services */}
      <section className="section" style={{background: 'var(--secondary-light)'}}>
        <div className="container">
          <div className="section-header">
            <h2>Commercial Construction Services</h2>
            <p>Complete mechanical system installation for commercial and mission-critical facilities</p>
          </div>
          
          <div style={{maxWidth: '1000px', margin: '0 auto'}}>
            <div className="commissioning-services-grid" style={{
              display: 'grid', 
              gridTemplateColumns: 'repeat(3, 1fr)', 
              gap: '1.5rem'
            }}>
              <div className="commissioning-service-card" style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(0, 104, 166, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>ac_unit</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '0.75rem', color: 'var(--white)'}}>Commercial HVAC Systems</h3>
                <p style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.95rem', lineHeight: '1.6'}}>Large-scale commercial and mission-critical HVAC system installation with redundancy and precision control.</p>
              </div>
              <div className="commissioning-service-card" style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(171, 22, 54, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>plumbing</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '0.75rem', color: 'var(--white)'}}>Commercial Plumbing & Piping</h3>
                <p style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.95rem', lineHeight: '1.6'}}>Industrial-grade plumbing systems and process piping for commercial facilities and specialized applications.</p>
              </div>
              <div className="commissioning-service-card" style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(0, 104, 166, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>air</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '0.75rem', color: 'var(--white)'}}>Commercial Ductwork Systems</h3>
                <p style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.95rem', lineHeight: '1.6'}}>Large-scale commercial ductwork fabrication and installation for complex air distribution systems.</p>
              </div>
              <div className="commissioning-service-card" style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(171, 22, 54, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>settings</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '0.75rem', color: 'var(--white)'}}>Building Automation Systems</h3>
                <p style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.95rem', lineHeight: '1.6'}}>Advanced commercial building automation and mission-critical control system integration.</p>
              </div>
              <div className="commissioning-service-card" style={{
                background: 'linear-gradient(135deg, var(--accent-blue) 0%, rgba(0, 104, 166, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(0, 104, 166, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>precision_manufacturing</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '0.75rem', color: 'var(--white)'}}>Commercial Equipment Installation</h3>
                <p style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.95rem', lineHeight: '1.6'}}>Professional installation of large-scale commercial mechanical equipment and systems.</p>
              </div>
              <div className="commissioning-service-card" style={{
                background: 'linear-gradient(135deg, var(--accent2-red) 0%, rgba(171, 22, 54, 0.85) 100%)', 
                color: 'var(--white)', 
                padding: '2rem 2.5rem', 
                borderRadius: '10px', 
                boxShadow: '0 4px 20px rgba(171, 22, 54, 0.2)',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1rem'}}><span className="material-icons" style={{fontSize: 'inherit', color: 'var(--white)'}}>verified</span></div>
                <h3 style={{fontSize: '1.3rem', marginBottom: '0.75rem', color: 'var(--white)'}}>Mission-Critical Testing</h3>
                <p style={{color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.95rem', lineHeight: '1.6'}}>Comprehensive testing and validation for mission-critical commercial systems.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default ConstructionCommissioning;
